import { Injectable } from '@angular/core';
import { EmpresasUsuario } from '../Modelos/empresas_usuario';
import { TokenALO } from '../Modelos/TokenALO';
import { CredencialesEmpresa } from '../Modelos/CredencialesEmpresa';
import { CredencialRETO } from '../Modelos/credencialRETO';
import { MbsSelect } from '../Modelos/mbsSelect';
import { Documento } from '../Modelos/documento';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { RT0001Transaccion } from '../Modelos/RT0001Transaccion';
import { Provincia } from '../Modelos/provincia';
import { Poblacion } from '../Modelos/poblacion';

@Injectable({
  providedIn: 'root'
})
export class VariablesService {

  public loginCorrecto: boolean;
  public usuario: string;
  public pwd: string;
  public autorizacionBase64: string;
  public empresasUsuario: EmpresasUsuario[];
  public empresaSeleccionada: EmpresasUsuario;
  public recordarUsuario: boolean;
  public motivoFichaje: string;
  public itemsPorColumna: number;
  public tokenLogin: TokenALO;

  public claveEncriptacion: string = "ALOReto";

  public metodoAcceso: string = "CredencialALO"

  public credencialesEmpresa: CredencialesEmpresa;

  public clavePwdEmpresas: string = "Ej69Tm9qmHYLWTaf";

  public credencialesRETO: CredencialRETO = {
    ContraseñaReto: "",
    UsuarioReto: ""
  }
  public filtroEstado: number = 0;
  public filtroTipo: string = "";
  public filtroCodigo: string = "";
  public filtroROPO: string = "";

  public filtroAlmacen: string = ""
  public fechaInicial: string;
  public fechaInicialTexto: string;
  public fechaFin: string;
  public fechaFinTexto: string;
  public almacenes: MbsSelect[];

  public ropos: MbsSelect[];
  public seleccionados: Documento[];
  public enviando: boolean;
  public totalEnviar: number;
  public documentosEnviados: number;
  public progresoSubidaTotal: number;
  public progresoSubidaArchivo: number;
  public appSegundoPlano: any;

  public NIFResponsable: string = ''
  public gridView: GridDataResult

  public transaccionesEnReto: RT0001Transaccion[]
  public credencialRetoValida : boolean
  poblaciones: Poblacion[];
  provincias: Provincia[];

  constructor() {
    this.loginCorrecto = false;
    this.usuario = "";
    this.pwd = "";
    this.autorizacionBase64 = "";
    this.empresasUsuario = [];
    this.empresaSeleccionada = null
    this.recordarUsuario = false;
    this.motivoFichaje = null;
    this.itemsPorColumna = null;
    this.tokenLogin = null;
    this.almacenes = [];
    this.ropos = [];
    this.seleccionados = [];
  }

}